import { useCallback, useEffect, useState } from 'react'
import type { SidebarState } from './useSidebarState.types'

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'TENANT_UI_SIDEBAR_COLLAPSED'
const DRAWER_MEDIA_QUERY = '(max-width: 991.98px)'

export function useSidebarState(): SidebarState {
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true'
  )
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(isCollapsed))
  }, [isCollapsed])

  useEffect(() => {
    if (!isDrawerOpen) {
      return
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsDrawerOpen(false)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isDrawerOpen])

  const toggleSidebar = useCallback(() => {
    const isDrawerViewport =
      typeof window.matchMedia === 'function' &&
      window.matchMedia(DRAWER_MEDIA_QUERY).matches
    if (isDrawerViewport) {
      setIsDrawerOpen((isOpen) => !isOpen)
      return
    }
    setIsCollapsed((collapsed) => !collapsed)
  }, [])

  const closeDrawer = useCallback(() => setIsDrawerOpen(false), [])

  return { isCollapsed, isDrawerOpen, toggleSidebar, closeDrawer }
}
